import { Box, Stack, Typography } from "@mui/material";

interface IOnboardingStepHeadingProps {
  heading: string;
  headingAccent?: string;
  paragraphs: string[];
}

function OnboardingStepHeading({
  heading,
  headingAccent,
  paragraphs,
}: IOnboardingStepHeadingProps) {
  return (
    <Box>
      <Typography
        component="h1"
        sx={{
          fontSize: { xs: 32, md: 42 },
          fontWeight: 600,
          lineHeight: 1.15,
          color: "text.primary",
        }}
      >
        {heading}{" "}
        {headingAccent && (
          <Box
            component="span"
            sx={{
              color: "primary.main",
              display: { xs: "inline", md: "block" },
            }}
          >
            {headingAccent}
          </Box>
        )}
      </Typography>
      <Stack spacing={2} mt={3}>
        {paragraphs.map((text) => (
          <Typography
            key={text}
            variant="body1"
            color="text.secondary"
            sx={{ fontSize: { xs: 16, md: 18 }, lineHeight: 1.6 }}
          >
            {text}
          </Typography>
        ))}
      </Stack>
    </Box>
  );
}

export default OnboardingStepHeading;
